import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ArrowDown as ArrowDownIcon } from "@phosphor-icons/react/dist/ssr/ArrowDown";
import { ArrowUp as ArrowUpIcon } from "@phosphor-icons/react/dist/ssr/ArrowUp";
import { Users as UsersIcon } from "@phosphor-icons/react/dist/ssr/Users";

export interface TotalCustomersProps {
  diff?: number;
  trend: "up" | "down";
  value: string;
}

export const TotalCustomers: React.FC<TotalCustomersProps> = ({
  diff,
  trend,
  value,
}) => {
  const TrendIcon = trend === "up" ? ArrowUpIcon : ArrowDownIcon;
  const trendColor = trend === "up" ? "green" : "red";

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Stack
            direction="row"
            sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
            spacing={3}
          >
            <Stack spacing={1}>
              <Typography color="text.secondary" variant="h4">
                TOTAL USERS
              </Typography>
              <Typography variant="h4">{value}</Typography>
            </Stack>
            <Avatar
              sx={{ backgroundColor: "#3da58a", height: "56px", width: "56px" }}
            >
              <UsersIcon fontSize="160%" />
            </Avatar>
          </Stack>
          {diff !== undefined ? (
            <Stack sx={{ alignItems: "center" }} direction="row" spacing={2}>
              <Stack
                sx={{ alignItems: "center" }}
                direction="row"
                spacing={0.5}
              >
                <TrendIcon color={trendColor} fontSize="15" />
                <Typography color={trendColor} variant="h5">
                  {diff}%
                </Typography>
              </Stack>
              <Typography color="text.secondary" variant="h5">
                Since last 7 days
              </Typography>
            </Stack>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  );
};
